import { render, staticRenderFns } from "./PazienteEditComponent.vue?vue&type=template&id=242da3bf"
import script from "./PazienteEditComponent.vue?vue&type=script&lang=js"
export * from "./PazienteEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports